import React, { Component } from 'react';

import './Footer.scss';

class Footer extends Component {
  render () {
    return (
      <div className='footer'>
        <span></span>
        <div>富金富蓝领数科服务平台</div>
        <span></span>
      </div>
    )
  }
}

export default Footer;